export enum StrapiComponentType {
  hero = "sections.hero-slider",
  benefits = "sections.benefits-section",
  imageSlider = "sections.image-slider",
  media = "media.media",
  link = "shared.link",
  clientsAboutUs = "sections.clients-about-us",
  specificProductSlider = "sections.product-slider",
  categoryProductSlider = "sections.category-product-slider",
  postSlider = "sections.post-slider",
  imageGallerySlider = "sections.image-gallery-slider",
  boxFinder = "sections.box-finder",
}

export interface StrapiComponent {
  id?: number | string;
  __component: StrapiComponentType | string;
}
